module.exports = __webpack_public_path__ + "static/media/29FUNOV13.b5c1c7cf.jpg";